import { useCallback, useEffect, useState } from "react";
import useIntelligentTimer from "./useIntelligentTimer";
// Hide the cursor after 5s of inactivity
var timeout = 5000;
var useHiddenCursor = function () {
    // Hide the cursor if the user is inactive on the whole page
    var startTimer = useIntelligentTimer()[0];
    var _a = useState(false), hidden = _a[0], setHidden = _a[1];
    // Show the cursor for x milliseconds
    var show = useCallback(function (time) {
        setHidden(false);
        startTimer(function () { return setHidden(true); }, time);
    }, [startTimer]);
    // Show the cursor as soon as the user interacts with the page
    useEffect(function () {
        var callback = function () { return show(timeout); };
        document.addEventListener("mouseenter", callback);
        document.addEventListener("mousemove", callback);
        return function () {
            document.removeEventListener("mouseenter", callback);
            document.removeEventListener("mousemove", callback);
        };
    }, [show]);
    // Hide the cursor when inactive (not sleeping, as that happens on mouse exit)
    useEffect(function () {
        if (hidden)
            document.documentElement.style.cursor = "none";
        else
            document.documentElement.style.removeProperty("cursor");
    }, [hidden]);
    // Expose the state and the active function
    return [hidden, show];
};
export default useHiddenCursor;
